import { useTranslation } from "react-i18next";

import { useConfiguration } from "@/api/configuration";
import type { DemandHistoryGroup } from "@/api/demandForecast";
import type { ViewRange } from "@/components/demand-chart/types";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatCurrency, formatNumber, parseDate } from "@/utils/formatters";

export type TotalsInViewCardProps = {
  groups: DemandHistoryGroup[];
  viewRange: ViewRange;
};

export function TotalsInViewCard({ groups, viewRange }: TotalsInViewCardProps) {
  const { t } = useTranslation();
  const { data: config } = useConfiguration();
  const currency = config?.currencyCode ?? "EUR";

  let quantity = 0;
  let revenue = 0;
  for (const g of groups) {
    for (const p of g.points) {
      const t = parseDate(p.date).getTime();
      if (t < viewRange.min || t > viewRange.max) continue;
      quantity += p.quantity;
      revenue += p.revenue;
    }
  }
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm">{t("demand.totals.heading")}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-1 text-sm">
        <div>
          {formatNumber(quantity, { maximumFractionDigits: 0 })}{" "}
          {t("demand.totals.units")}
        </div>
        <div>
          {formatCurrency(revenue, currency, { maximumFractionDigits: 0 })}
        </div>
      </CardContent>
    </Card>
  );
}
